import { useMemo } from 'react';
import {
    formatBytes,
    formatDecimal,
    formatDuration,
    formatInteger,
    formatMilliseconds,
    formatPercent,
} from '../utils/formatters';

export const useServiceMetricSummaries = (metrics) => {
    const uptime = useMemo(() => formatDuration(metrics?.uptimeSeconds), [metrics?.uptimeSeconds]);
    const cpuUsage = useMemo(() => formatPercent(metrics?.cpuUsage), [metrics?.cpuUsage]);
    const load = useMemo(() => formatDecimal(metrics?.systemLoad1m), [metrics?.systemLoad1m]);
    const memoryUsed = useMemo(() => formatBytes(metrics?.memory?.usedBytes), [metrics?.memory?.usedBytes]);
    const memoryMax = useMemo(() => formatBytes(metrics?.memory?.maxBytes), [metrics?.memory?.maxBytes]);
    const totalRequests = useMemo(() => formatInteger(metrics?.requests?.totalCount), [metrics?.requests?.totalCount]);
    const errorCount = useMemo(() => formatInteger(metrics?.requests?.errorCount), [metrics?.requests?.errorCount]);
    const avgLatency = useMemo(
        () => formatMilliseconds(metrics?.requests?.averageResponseMs),
        [metrics?.requests?.averageResponseMs],
    );

    const endpointSamples = metrics?.requests?.endpointSamples || [];

    return {
        uptime,
        cpuUsage,
        load,
        memoryUsed,
        memoryMax,
        totalRequests,
        errorCount,
        avgLatency,
        endpointSamples,
    };
};

export default useServiceMetricSummaries;
